import { useEffect } from 'react';

export function usePageViews(): void {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    window.analytics.page(`${window.document.title}`);
  }, [window.document.title]);
}
